/*==================================================
 *  Common localization strings
 *==================================================
 */

Timeline.strings["nl"] = {
    wikiLinkLabel:  "Discussieer"
};




//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/lib/simile-timeline/timeline_js/scripts/l10n/nl/timeline.js
// module id = 588
// module chunks = 3